const faqs = [
  {
    q: '911爆料网的内容来源可靠吗？',
    a: '911爆料网拥有专业的内容采编团队，所有爆料内容均经过多渠道信息交叉验证后方可发布。我们与多个行业内部人士保持长期合作，确保信息的真实性和及时性。同时，我们严格标注信息来源类型，方便读者自行判断可信度。对于未经证实的传闻，我们会在显著位置标注「待证实」。',
  },
  {
    q: '如何在911爆料网投稿爆料？',
    a: '你可以通过页面底部的「联系我们」区域找到投稿入口。我们支持文字、图片、视频等多种形式的爆料材料提交。911爆料网承诺对所有爆料人信息严格保密，采用端到端加密技术保护你的隐私安全。投稿一经采纳，我们将根据内容价值给予相应报酬。',
  },
  {
    q: '911爆料网更新频率是怎样的？',
    a: '我们实行7×24小时不间断更新机制，内容编辑团队三班轮值，确保第一时间追踪热点事件。平均每天更新50条以上的爆料资讯，重大热点事件发生时，我们会在15分钟内发出首条快讯，并在后续持续跟进深度报道和多方核实。',
  },
  {
    q: '911爆料网的最新入口地址在哪里获取？',
    a: '你可以将本页面（911爆料网官方首页）添加至浏览器收藏夹，这是最稳定的访问方式。同时，你也可以关注我们的官方社交媒体账号获取最新地址更新。建议优先使用收藏本站的方式，确保随时都能顺利访问。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-sm text-accent-600 font-medium bg-accent-50 px-3 py-1 rounded-full">答疑解惑</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-950">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-500">关于911爆料网，你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6">
              <div className="flex items-start gap-3">
                <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center bg-primary-100 text-primary-600 rounded-full text-sm font-bold">{index + 1}</span>
                <div>
                  <h3 className="text-base font-medium text-foreground-900 mb-2">{faq.q}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}